var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_Promise.js
// module id = 822
// module chunks = 0 1 2 3 4 5 6 7 8